import { connect } from 'react-redux';
import { alertsIdsByGroupId } from '../../AlertsSelectors';
import GroupItem from './GroupItem';

function mapStateToProps(state, ownProps) {
  return {
    alertsIds: alertsIdsByGroupId(state, ownProps),
  };
}

export default connect(mapStateToProps)(GroupItem);
